import { useEffect, useState } from "react";
import Loader from "./loader";

const PreloadImages = ({ staticImages = [], dynamicImageLists = [], onComplete }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const preloadSet = new Set();
    let total = 0;
    let loaded = 0;

    const dynamicUrls = dynamicImageLists.flatMap(({ list, key }) =>
      list.map((item) => item?.[key]).filter(Boolean)
    );

    const allImages = [...staticImages, ...dynamicUrls];
    total = allImages.length;

    if (total === 0) {
      setLoading(false);
      onComplete?.();
      return;
    }

    allImages.forEach((src) => {
      if (src && !preloadSet.has(src)) {
        const img = new Image();
        img.src = src;
        img.onload = img.onerror = () => {
          loaded++;
          if (loaded >= total) {
            setLoading(false);
            onComplete?.();
          }
        };
        preloadSet.add(src);
      }
    });
  }, [staticImages, dynamicImageLists, onComplete]);

  if (!loading) return null;

  return (
    <Loader />
  );
};

export default PreloadImages;
